import Vue from 'vue';
import VueGtag from 'vue-gtag';
// import VueAnalytics from 'vue-analytics';
import router from '@/router';

Vue.use(
  VueGtag,
  {
    config: {
      id: process.env.VUE_APP_VUEANALYTICS_ID,
      params: {
        send_page_view: false,
      },
    },
    //

    // debug: {
    //   sendHitTask: true,
    // },
  },
  router,
);

Vue.prototype.$analytics = function analytics(
  eventCategory,
  eventAction,
  eventLabel,
  eventValue,
) {
  this.$gtag.event(eventAction, {
    event_category: eventCategory,
    event_label: eventLabel,
    value: eventValue,
  });
};
